import { IResource } from '@models/Resource.model';
import { getPermissionData } from '@utils';
import { ChangeMutation } from './ResourceLink.types';

export function handleClick(
  favoritePermission: ReturnType<typeof getPermissionData>,
  changeMutation: ChangeMutation,
  resource: IResource,
) {
  return () => {
    if (favoritePermission.allowed) {
      changeMutation.mutate({
        data: {
          resourceId: resource.id,
          favorite: !resource.favorite,
        },
      });
    }
  };
}
